import { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
// material
import { alpha } from "@mui/material/styles";
import { Avatar, IconButton } from "@mui/material";
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const history = useHistory();

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={() => history.push("/3/app/profile")}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Avatar
          src={"https://cdn-icons-png.flaticon.com/512/3135/3135789.png"}
          alt="photoURL"
        />
      </IconButton>
    </>
  );
}
